// extracted by mini-css-extract-plugin
export default {"google_container":"GoogleAuth_google_container__7anef"};